import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-消耗流水",
  "use": "icon-消耗流水-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-消耗流水\">\n<g transform=\"translate(2 2) scale(0.75)\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"0.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n\t<path d=\"M4.3,1.8h5.4l3,3v9.4H4.3c-0.7,0-1.2-0.5-1.2-1.2V3C3.1,2.3,3.6,1.8,4.3,1.8z\" />\n\t<path d=\"M9.7,1.8v3h3\" />\n\t<path d=\"M5.2,7.3h4.8\" />\n\t<path d=\"M5.2,9.6h3\" />\n\t<path d=\"M5.2,11.9h4.2\" />\n\t<path d=\"M10.3,8.8l1.7,1.7l1.7-1.7\" />\n\t<path d=\"M12,7v3.5\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/消耗流水.svg
// module id = I5J7
// module chunks = 166